<template>
  <div v-clickoutside="handleClose">
    <div class="change-btn"
         :class="{'show':showList}"
         @click="showList = !showList">
      <div>选择企业</div>
      <i class="el-icon-d-arrow-left"
         :class="!showList ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"></i>
    </div>
    <!-- 企业列表 v-clickoutside="showList=false"-->
    <div class="company-list"
         :class="{'show':showList}">
      <p>选择企业</p>
      <div class="company-search">
        <el-input size="small" clearable @clear="clearBtn" placeholder="请输入企业名称" v-model="searchInfo.companyName">
          <el-button slot="append" icon="el-icon-search" @click="searchBtn"></el-button>
        </el-input>

        <!-- <el-button size="small" type="danger" icon="el-icon-refresh" @click="clearBtn"></el-button> -->
      </div>
      <ul v-if="tableData.length>0">
        <!-- <li>全部</li> -->
        <li :class="{'is-active': item.id == projectId}" v-for="(item, key) in tableData" :key="key" @click.stop="goCompanyInfo(item)">
          <div class="company-name">{{item.enterpriseName}}</div>
          <div class="company-address">{{item.address}}</div>
        </li>
      </ul>
      <el-empty v-else description="暂无数据"></el-empty>
      <div class="page-paginnation">
        <pagination :totalRecords="totalRecords"
                    :pageSize="pageSize"
                    :pageIndex="pageIndex"
                    layout="total, prev, pager, next"
                    @changePageSize="changePageSize"
                    @changePageNumber="changePageNumber"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProjectList // 企业分页列表
} from '@/api/common'
export default {
  name: 'companyList',
  data () {
    return {
      searchInfo: {
        companyName: ''
      },
      searchData: {
        companyName: ''
      },
      tableData: [],
      totalRecords: 0,
      pageSize: 10,
      pageIndex: 1,
      showList: false
    }
  },
  computed: {
    projectId () {
      return this.$store.getters.projectId
    },
    isAddCompany () {
      return this.$store.getters.isAddCompany
    }
  },
  watch: {
    pageIndex: {
      handler (newVal, oldVal) {
        this.getProjectList()
      },
      deep: true
    },
    pageSize (newVal) {
      this.getList()
    },
    isAddCompany (newVal) {
      this.getProjectList()
    }
  },
  created () {
    console.log('realTime')

    this.getProjectList()
  },
  methods: {
    handleClose () {
      // console.log(123)
      if (this.showList) {
        this.showList = false
      }
    },
    goCompanyInfo (item) {
      this.$store.dispatch('setProjectId', '')
      this.$store.dispatch('setProjectId', item.id)
      this.$store.dispatch('setProjectInfo', item)
      this.showList = false
    },
    // 页码跳转
    changePageNumber (val) {
      this.pageIndex = val
    },
    changePageSize (val) {
      this.pageSize = val
    },
    // 查询列表
    searchBtn () {
      this.searchData = { ...this.searchInfo }
      this.getList()
    },
    // 清空查询
    clearBtn () {
      this.searchInfo = {
        companyName: ''
      }
      this.searchBtn()
    },
    // 更新获取列表数据
    getList () {
      if (this.pageIndex === 1) {
        this.getProjectList()
      } else {
        this.pageIndex = 1
      }
    },
    async getProjectList () {
      let params = {
        enterpriseName: this.searchData.companyName,
        orderByColumn: '',
        isAsc: '',
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      let res = await getProjectList(params)
      if (res) {
        this.tableData = res.data
        this.totalRecords = res.totalRecords
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.change-btn {
    position: fixed;
    right: 380px;
    top: 200px;
    width: 30px;
    height: 120px;
    text-align: center;
    padding: 10px;
    color: #fff;
    z-index: 9999999;
    background-color: $--color-primary;
    border-radius: 5px 0 0 5px;
    transition: all 1s;
    cursor: pointer;
    transform: translateX(380px);
    z-index: 5;
    div {
      margin-bottom: 10px;
    }
    &.show{
      transform: translateX(0px);
    }
  }
.company-list {
  box-shadow: 2px 0px 30px 0px rgba(60, 60, 67, 0.19);
  position: fixed;
  top: 80px;
  right: 0px;
  width: 380px;
  // height: calc(100% - 110px);
  background-color: #fff;
  box-shadow: 0 0 8px 2px #ccc;
  border-radius: 3px;
  transition: all 1s;
  height: calc(100% - 100px);
  // padding: 0;
  padding: 15px 20px 20px 20px;
  overflow-y: auto;
  transform: translateX(380px);
  z-index: 4;
  & > p {
    color: $--color-primary;
    margin-bottom: 15px;
    position: relative;
    &::after{
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 30px;
      height: 2px;
      background: $--color-primary;
      border-radius: 1px;
    }
  }
  // .list-hidden{
  //   // position: absolute;
  //   // top: 10px;
  //   // left: 26px;
  //   // cursor: pointer;
  //   i{
  //     font-size: 20px;
  //   }
  // }
  .company-search {
    margin-bottom: 10px;
  }
  & > ul {
    // padding: 0 10px;
    height: calc(100% - 130px);
    overflow-y: auto;
    li {
      line-height: 24px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      padding: 8px 10px;
      &:hover{
        background-color: rgba($color: #eee, $alpha:0.3);
      }
    }
    .is-active{
      background-color: rgba($color: #eee, $alpha:0.5);
    }
    .company-name {
      font-size: 15px;
    }
    .company-address {
      color: rgba(105, 110, 110, 0.5);
    }
  }
  &.show {
    // height: calc(100% - 110px);
    // padding: 15px 20px 20px 20px;
    transform: translateX(0);
  }
}
</style>
